import brand, { ThemeOption } from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { h3 } from '@helpers/typography';
import { LinkButton } from '@stories/Components/Buttons/Button/Button';
import styled from 'styled-components';
const Container = styled.div `
  border: 2px solid var(--themeColor);
`;
const Title = styled.h3 `
  ${h3};
  color: ${brand.white};
  background-color: var(--themeColor);
  padding: 16px 30px;
  margin-bottom: 0;
`;
const Content = styled.div `
  padding: ${fluid(20, 30)} ${fluid(31, 28)};
`;
const Information = styled.div `
  display: flex;
  margin-bottom: 10px;

  > span {
    font-size: 16px;
    line-height: 22px;
  }
`;
const InformationIcon = styled.div `
  min-width: 23px;
  margin-right: 2px;
  flex-shrink: 0;
`;
const Hr = styled.hr `
  margin: 0.8em 0 1em;
  border-color: var(--themeColor);
  border-style: solid;
`;
const Cta = styled(LinkButton) `
  &&& {
    --buttonHeight: auto;
  }

  margin-top: 0.5em;
  border: none;
  --buttonFgColor: ${brand.white};

  body[data-page-theme=${ThemeOption.Orange}] & {
    --buttonBgColor: ${brand.orange};
  }

  body[data-page-theme=${ThemeOption.Blue}] & {
    --buttonBgColor: ${brand.blue};
  }

  body[data-page-theme=${ThemeOption.Purple}] & {
    --buttonBgColor: ${brand.purple};
  }

  body[data-page-theme=${ThemeOption.Red}] & {
    --buttonBgColor: ${brand.red};
  }

  body[data-page-theme=${ThemeOption.Green}] & {
    --buttonBgColor: ${brand.green.default};
  }

  body[data-page-theme=${ThemeOption.DarkGreen}] & {
    --buttonBgColor: ${brand.green.dark};
  }

  body[data-page-theme=${ThemeOption.Teal}] & {
    --buttonBgColor: ${brand.teal};
  }
`;
export const KeyInformationCardStyles = {
    Container,
    Content,
    Cta,
    Hr,
    Information,
    InformationIcon,
    Title,
};
